export const diagnosisItems = ['전체', '검사 미지정', '검사 시작 전', '검사 진행중', '검사 완료'];

export const todayDiagnosisNothingLists = {
    text: '표시할 진료가 없습니다.',
    subText: '새로운 진료를 추가하여, 편리하게 관리해보세요!',
    buttonText: '진료 추가',
};
